import { toHumanReadableDate } from '@shared/services/dateService';

const InvoicesMapper = {
  toTableData: invoices =>
    invoices.map(invoice => ({
      id: invoice.Id,
      orgUnit: invoice.OrgUnit,
      invoiceNumber: invoice.InvoiceNumber,
      purchaseOrderNumber: invoice.PurchaseOrderNumber,
      dueDate: toHumanReadableDate(invoice.DueDate),
      isPastDue: invoice.IsPastDue,
      invoiceTotal: invoice.InvoiceTotal,
      status: invoice.Status,
      description: invoice.Description
    }))
};

export default InvoicesMapper;
